import { FilterSelectionOption } from '@core/ui';
import { IndustryCatalogTaskFilter } from '@mp/content-manager/industriekataloge/data-access';

export const CATALOG_OPEN_TASKS_FILTER_OPTIONS: FilterSelectionOption<IndustryCatalogTaskFilter>[] = [
  {
    value: IndustryCatalogTaskFilter.PLATFORM_SUPPLIER_ASGMT,
    label: 'Plattformlieferanten',
    icon: 'local_shipping',
  },
  {
    value: IndustryCatalogTaskFilter.SUPPLIER_ASGMT,
    label: 'Bezugsquellen',
    icon: 'local_shipping',
  },
  {
    value: IndustryCatalogTaskFilter.MANUFACTURE_ASGMT,
    label: 'Hersteller',
    icon: 'factory',
  },
  {
    value: IndustryCatalogTaskFilter.PACKAGING_UNITS_ASGMT,
    label: 'Packungseinheiten',
    icon: 'straighten',
  },
];
